/* Copyright (c) 2020 IceRock MAG Inc. Use of this source code is governed by the Apache 2.0 license. */

import React, { FC, MouseEventHandler, useCallback } from "react";

type IProps = {
  label: string;
  value: any;
  error?: string;
  isEditing?: boolean;
  onClick?: MouseEventHandler<HTMLDivElement>;
  handler?: (val: any) => void;
  data: Record<string, any>;
} & Record<string, any>;

const OrderSpentHoursInternal: FC<IProps> = ({
  value,
  onClick,
  data,
}) => {
  return (
    <div onClick={onClick}>
      {data?.spentHours?.internalSpentHours ? (
        parseFloat(data?.spentHours?.internalSpentHours.toFixed(2)) || '0'
      ) : (
        <div>0</div>
      )}
    </div>
  );
};

export { OrderSpentHoursInternal };
